import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#222",
		d: "m12.45 6.987-6.656 6.657c-.221.22-.494.384-.792.475l-2.77.84h-.003a.955.955 0 0 1-1.19-1.187l.002-.002.84-2.77v-.002c.093-.3.257-.571.478-.792l6.654-6.657zM12.57 1a2.43 2.43 0 0 1 1.801 4.062l-.083.087-.938.938-3.437-3.438.938-.937A2.43 2.43 0 0 1 12.571 1"
	})
});
export default SvgEdit;
